import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { dateToString, encodeBase64, handleGetCookie, checkPermissionByPath, FormatCurrencys } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import { callExportAgent } from "../../../api/export";
import { addVehicleContract, callCancelContract, callCheckRenew, callGetContractByKey, cancelVehicleContract } from "../../../api/contract/service";
import SmartTable from "../../../components/common/table-component";
import PermissionWrapper from "../../../components/common/PermissionWrapper";
import SwalAlert from "../../../components/common/alert";

import { CREATE, EDIT, PRINT, DELETE, CLAME } from "../../../utils/commonType"
import { callUploadFile } from "../../../api/settings/service";
import { Modal } from "bootstrap";
import { stringify } from "crypto-js/enc-base64";
import FileUploadGrid from "../../../components/upload-file";
import DatePicker from "react-datepicker";
import { render } from "@testing-library/react";
const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ startYea: null, endYear: null, page: 1, maxResult: 10, keyword: '', modifiedCode: '', modifiedName: '' });
	const [contract, setContract] = useState({ totalPages: 0, totalRecords: 0, result: [] });
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(0);
	const location = useLocation();
	const [requestCancel, setRequestCancel] = useState({ contractNumber: '', documentPath: '', reason: '', carriedCode: '', carriedName: '', file: null });
	const fileInputRef = useRef();

	useEffect(() => {
		loadData();
	}, [location.state]);
	const columns = [
		{
			label: 'lifeContractNumber', key: 'id', render: (val, item) => (
				<button className="btn btn-link" onClick={() => navigate(pathname + "/detail/" + encodeBase64(JSON.stringify(item)))}>{val}</button>
			)
		},
		{ label: 'lifeContractFullName', style: { minWidth: '156px' }, key: 'fullName' },
		{ label: 'lifeContractAddress', style: { minWidth: '280px' }, key: 'address' },
		{ label: 'lifeContractAgentCode', style: { minWidth: '156px' }, key: 'agentCode' },
		{
			label: 'lifeContractPackageName', style: { minWidth: '156px' }, key: 'optionNameLa', render: (val, item) =>
				val ? val + "/" + FormatCurrencys(item.packagePrice) + "/" + item.amountDay + t("day") : '-'
		},

		{
			label: 'lifeContractStatus', key: 'status', render: (val) => (
				<span className={"badge " + (val === 1 ? "bg-success" : "bg-danger")}>{t('status.' + val)}</span>
			)
		},
		{
			label: 'lifeContractStatusPayment', key: 'statusPayment', render: (val) => (
				<span className={"badge " + (val === 1 ? "bg-success" : "bg-danger")}>{t('statusPayment.' + val)}</span>
			)
		},

		{
			label: 'lifeContractCarriredDate', key: 'carriredDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'vehicleContractSignedDate', key: 'signedDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'vehicleContractCreateAt', key: 'createdAt', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'lifeContractCreateBy', style: { minWidth: '100px' }, key: 'createdBy', render: (val) => (
				val ? val : '-'
			)
		},
		{
			label: 'lifeContractUpdateAt', key: 'updatedAt', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'lifeContractUpdateBy', style: { minWidth: '100px' }, key: 'updatedBy', render: (val) => (
				val ? val : '-'
			)
		}
	];


	const loadData = async (e) => {
		if (userInfo?.data.user.userTypeId === 3 && !userInfo?.data?.agent?.agentId) {
			SwalAlert.error("", __t("uiText.text292"));
			return;

		}
		let data = { startDate: request.fromDate, endDate: request.toDate, keyword: request.keyword, page: request.page, maxResult: request.maxResult, insuranceType: 2, agentId: userInfo?.data?.agent?.agentId };
		if (e) {
			data = { ...data, insuranceType: 2, ...e }
		}
		const rsp = await dispatch(callGetContractByKey(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setContract(rsp.payload.data)
		}

	}

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};
	const handleChangeCancel = (e) => {
		const { name, value } = e.target;
		setRequestCancel((prev) => ({
			...prev,
			[name]: value
		})
		);
	};
	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const handleEdit = (id) => {
		navigate(pathname + "/save/" + encodeBase64(id.contractNumber))
	}
	const handleRenew = async (id) => {
		const res = await dispatch(callCheckRenew({ customerId: id.customerId }))
		if (res?.payload?.responseCode === "00000") {
			navigate(pathname + "/renew/" + encodeBase64(id.contractNumber))
		} else {
			SwalAlert.error(__t("uiText.text023"), t("errors.renew_" + res?.payload?.responseCode) + res?.payload?.responseDescription);
		}

	}
	const handleClaimCenter = (item) => {
		// Vehicle insurance can have many cases and many claims.
		// Always enter the claim center first instead of trying to resolve one
		// case from the contract here.
		navigate(pathname + "/claims/" + encodeBase64(item.contractNumber));
	}

	const handleDelete = (item) => {
		SwalAlert.confirm(t("titleDelete"), t("confirmDelete"), async () => {
			try {
				const rsp = await dispatch(callCancelContract({ contractNumber: item.contractNumber, insuranceType: 2 }));
				if (rsp?.payload?.responseCode === "00000") {
					SwalAlert.success(t("success.delete"), () => {
						loadData();
					});
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), __t("uiText.text024"),);
			}
		})
	}

	const downloadExcel = async () => {
		try {
			let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, reportType: 0, reportValue: null };
			let response = await callExportAgent(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = `agent_${moment().format("YYYYMMDDHHmmss")}.xlsx`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};
	const triggerFileInput = () => {
		fileInputRef.current.click();

	};

	const cancelSeletedFile = () => {
		setRequestCancel((prev) => ({
			...prev,
			file: null
		}));
	};
	const handleImageSelect = (e) => {
		setRequestCancel((prev) => ({
			...prev,
			file: { file: e }
		}));
	};
	const handleSave = async (e) => {
		e.preventDefault()
		SwalAlert.confirm(t("swal.title.titleReqCancel"), t("swal.text.textReqCancel"), async () => {
			try {
				let error = null;
				let documentPath = null;

				// Upload file if exists
				if (requestCancel.file?.file) {
					const upload = await dispatch(callUploadFile(requestCancel.file.file));

					if (upload?.payload?.responseCode === "00000") {
						documentPath = JSON.stringify(upload?.payload?.data);
					} else {
						error = t('uploadFile.cancalVehicleContract');
					}
				}

				if (error) {
					SwalAlert.error(__t("uiText.text023"), error);
					return;
				}

				// Compose updated request object
				const updatedRequest = {
					...requestCancel,
					documentPath,
					carriedCode: userInfo?.data?.user?.userId,
					carriedName: `${userInfo?.data?.user?.firstName} ${userInfo?.data?.user?.lastName || ''}`
				};
				const rsp = await dispatch(cancelVehicleContract(updatedRequest));
				if (rsp?.payload?.responseCode === "00000") {
					const myModal = document.getElementById("cancelPopupModal");
					const modal = Modal.getInstance(myModal);
					modal.hide();
				} else {
					SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), error.toString());
			}
		});
	};

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.contractControl.vehicleInsuranceContract")}</h4>
						<div className="group-button-header">
							{
								<PermissionWrapper permission={CREATE}>
									<button type="button" className="btn btn-primary" onClick={() => navigate(pathname + '/save')}>
										<i className="fas fa-plus"></i> {t("button.add")}
									</button>
								</PermissionWrapper>

							}
							{/* {
								<PermissionWrapper permission={PRINT} >
									<button className="btn btn-success" onClick={downloadExcel}>
										<i className="fas fa-file-export"></i> {t("button.exportExcel")}
									</button>
								</PermissionWrapper>
							} */}
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="row">
											<div className="col-md-3">
												<div className="form-group">
													<label>{t('search.keyword')}</label>
													<input
														type="text"
														name="keyword"
														className="form-control-uld"
														placeholder={t('search.keyword') + "..."}
														onChange={handleChange}
														value={request.keyword}
														autoComplete="off"
														required />
												</div>
											</div>
											<div className="col-md-3 form-group">
												<label>{t('startDate')}</label>
												<DatePicker
													selected={request.fromDate}
													onChange={date => setRequest((prev) => ({ ...prev, fromDate: moment(date).format('YYYY-MM-DD') }))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('startDate')}
													className="form-control-uld"
												/>
											</div>

											<div className="col-md-3 form-group">
												<label>{t('endDate')}</label>
												<DatePicker
													selected={request.toDate}
													onChange={date => setRequest((prev) => ({ ...prev, toDate: moment(date).format('YYYY-MM-DD') }))}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('endDate')}
													className="form-control-uld"
												/>
											</div>
											<div className="col-auto auto-button">
												<label>&nbsp;</label>
												<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
													<i className="fas fa-search"></i>&nbsp;{t("button.search")}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={contract} keyword={request.keyword} onLazyLoad={loadData}
											actions={(item) => (
												<div style={{ minWidth: 200 }}>
													<PermissionWrapper permission={CLAME}>
														<button
															type="button"
															className="btn btn-success btn-sm"
															title={__t("uiText.text295")}
															onClick={() => handleClaimCenter(item)}
														>
															<i className="fas fa-car-crash"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={EDIT}>
														<button disabled={(item.status != 1 && item.status != -1) || item.statusPayment == 3} className="btn btn-primary btn-sm" onClick={() => handleRenew(item)}>
															<i className="fas fa-history"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={EDIT}>
														<button disabled={item.status != 1 && item.status != 3} className="btn btn-primary btn-sm" onClick={() => handleEdit(item)}>
															<i className="fas fa-pen"></i>
														</button>
													</PermissionWrapper>
													&nbsp;
													<PermissionWrapper permission={DELETE}>
														<button disabled={item.status != 1 && item.status != 3} className="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#cancelPopupModal" onClick={() => setRequestCancel((prev) => ({
															...prev,
															contractNumber: item.contractNumber,
															file: "",
															documentPath: "",
															reason: ""
														}))}>
															<i className="fas fa-trash"></i>
														</button>
													</PermissionWrapper>
												</div>
											)}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
			<div className="modal fade" id="cancelPopupModal">
				<div className="modal-dialog modal-lg modal-dialog-centered login-modal modal-dialog-scrollable">
					<div className="modal-content">
						<button
							type="button"
							className="closed-modal"
							data-bs-dismiss="modal"
						></button>
						{/* End close modal btn */}

						<div className="modal-body">
							{/* <!-- Login modal --> */}
							<div id="login-modal">
								{/* <!-- Login Form --> */}
								<div className="login-form default-form">
									<div className="form-inner">
										<h3>{t("contracts.vehicle.cancel")}</h3>
										<form onSubmit={handleSave}>
											<div className="default-form">
												<div className="row">
													<div className="col-md-12 form-group">
														<label> {t('contracts.vehicle.cancelDescription')}</label>
														<textarea
															id="reason"
															name="reason"
															rows="5"
															cols="40"
															value={requestCancel.reason}
															onChange={handleChangeCancel}
															placeholder={t('contracts.life.clame.description')}
														/>
													</div>
													<div className="col-12 col-md-12 form-group">
														<label> {t('contracts.vehicle.cancelFile')} <span className="text-danger">*</span> </label>
														<FileUploadGrid
															multiple={false}
															folderName="cancalVehicleContract"
															onChange={(e) => handleImageSelect(e)}
															accept="image/*,application/pdf"
															required
														/>
														{/* {
															requestCancel.file || requestCancel.documentPath ? (
																<div className="d-flex justify-content-center align-items-center flex-column text-center">
																	<div className="image-preview-box w-100">
																		{requestCancel.file ? requestCancel.file.file.name : request.vehicle.imagePath}
																		<div className="action-buttons d-flex flex-row gap-2">
																			{requestCancel.file && <button type="button" className="btn btn-danger" onClick={cancelSeletedFile}>{t("cancel")}</button>}
																		</div>
																	</div>
																</div>
															) :
																<div className="image-box upload-box w-100" onClick={triggerFileInput}>
																	<i className="fas fa-file-pdf camera-size"></i>
																</div>
														}
														<input
															type="file"
															accept="application/pdf"
															ref={(el) => fileInputRef.current = el}
															style={{ display: 'none' }}
															onChange={(e) => handleImageSelect(e, 'vehicle')}
														/> */}
													</div>
													<div className="col-12 d-flex justify-content-center">
														<div className="m-3">
															<button className="theme-btn btn-style-one w-100" type="submit">
																<i className="fas fa-add"></i>&nbsp;{t("button.save")}
															</button>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
								{/* <!--End Login Form --> */}
							</div>
							{/* <!-- End Login Module --> */}
						</div>
						{/* En modal-body */}
					</div>
					{/* End modal-content */}
				</div>
			</div>
		</div >
	);
};

export default Index;
